import { render, staticRenderFns } from "./couponLayout2.vue?vue&type=template&id=46be25a4&"
import script from "./couponLayout2.vue?vue&type=script&lang=ts&"
export * from "./couponLayout2.vue?vue&type=script&lang=ts&"
import style0 from "./couponLayout2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports